// 1.引入vue和vue-router并赋值给相应的Vue和Router
import Vue from 'vue';
import Router from 'vue-router';


//	解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}


import index from '@/components/index';
import seacherDetails from '@/components/seacherDetails';
import details from '@/components/details';
import hoc from '@/components/hoc';
import api from '@/components/api';
import mineinfo from '@/components/mineinfo';
import minerepwd from '@/components/minerepwd';
import minekey from '@/components/minekey';


// 2.通过Vue的use方法注入Router
Vue.use(Router)


// 3.创建 router 实例，然后传 `routes` 配置
const router = new Router({
	
    //	指定路由选中时的样式类名
    linkActiveClass: 'active',
	
	//	将路径格式化为#!开头
    hashbang: true, 
	
	//	启用HTML5 history模式，可以使用pushState和replaceState来管理记录
    history: true, 
	
	//	路由配置配置具体的路径
    routes: [
		{
			path:'/',
			redirect:'/index',
			meta: {
				keepAlive: false,
			},
		},
        {
            path: '/index',
            component: index,
			meta: {
				keepAlive: false,
			},
		},
        {
            path: '/seacherDetails',
            component: seacherDetails,
			meta: {
				keepAlive: true,
				isBack: false,
			},
		},
        {
            path: '/details',
            component: details,
			
		},
        {
            path: '/hoc',
            component: hoc,
			meta: {
				keepAlive: false,
			},
		},
		{
		    path: '/api',
		    component: api,
			meta: {
				keepAlive: false,
			},
		},
		{
		    path: '/mineinfo',
		    component: mineinfo,
			meta: {
				keepAlive: false,
			},
		},
		{
		    path: '/minerepwd',
		    component: minerepwd,
			meta: {
				keepAlive: false,
			},
		},
		{
		    path: '/minekey',
		    component: minekey,
			meta: {
				keepAlive: false,
			},
		}
		
    ]
})




/**
 * @desc 全局监听路由变化
 */
router.beforeEach((to, from, next) => {
    //	store.dispatch('updateHistoryLength') // 变化时更新路由切换长度

    next()
})


// 5.导出路由
export default router